export enum Source {
  Url = 'url',
  List = 'list',
  S3 = 's3',
  Function = 'function',
  Dependent = 'dependent',
}
